import { fechasLegibles } from './cifras';

/**
 * Mensajes de Alexia guardados antes de la revisión del 14 oct 2026 (chat,
 * resúmenes del escáner): se ven con las palabras y los formatos de hoy.
 *
 * - Fechas «2026-09-28» o «28/09/2026» → «28 sep».
 * - Importes sin punto de miles («2237,81 €», «$1234.56») → «2.237,81 €»,
 *   «$1,234.56».
 * - Los avisos viejos del escáner («No hemos encontrado…») → los de ahora; el
 *   del número de factura se quita (el escáner ya tiene el suyo).
 *
 * No cambia lo guardado: solo cómo se enseña.
 */

const AVISOS_VIEJOS: Array<[string, string]> = [
  ['No hemos encontrado el número de factura. Sin él no podemos avisarte si la repites.', ''],
  ['No hemos encontrado el total de la factura.', 'No veo el total de la factura.'],
  ['No hemos podido leer el importe. Escríbelo a mano.', 'No pude leer el importe. Escríbelo tú.'],
  ['No hemos podido leer la fecha; hemos puesto la de hoy.', 'No veo la fecha: puse la de hoy.'],
  ['La fecha de la factura es futura. Compruébala.', 'La fecha de la factura es de un día que no ha llegado. Compruébala.'],
  ['No hemos podido leer el proveedor. Elígelo o créalo a mano.', 'No veo el proveedor. Elígelo o escríbelo tú.'],
  ['El descuento leído no coincide con el subtotal y la base neta. Revisa los importes.', 'El descuento que leí no cuadra con el subtotal y el total sin IVA. Revisa los importes.'],
];

/** «2237,81 €» → «2.237,81 €»; «$1234.56» → «$1,234.56». Solo cifras sin agrupar. */
export function milesEnImportes(texto: string): string {
  const agrupar = (entero: string, sep: string): string => entero.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  return String(texto ?? '')
    .replace(/(^|[^\d.,])(\d{4,})(,\d{1,2})(\s?€)/g, (_t, antes: string, entero: string, dec: string, eur: string) => `${antes}${agrupar(entero, '.')}${dec}${eur}`)
    .replace(/(\$\s?)(\d{4,})(\.\d{1,2})?(?![\d,])/g, (_t, signo: string, entero: string, dec: string | undefined) => `${signo}${agrupar(entero, ',')}${dec ?? ''}`);
}

export function textoDeAlexiaLegible(texto: string, hoy?: string): string {
  let out = String(texto ?? '');
  for (const [viejo, nuevo] of AVISOS_VIEJOS) out = out.split(viejo).join(nuevo);
  out = milesEnImportes(fechasLegibles(out, hoy));
  // Lo que deja un aviso quitado: dobles espacios dentro de la línea.
  return out.replace(/(\S)[ \t]{2,}(?=\S)/g, '$1 ').replace(/[ \t]+$/gm, '').trim();
}
